import React from 'react';
import { Container, Gap } from './styles';

import SideBarList from '../../../../components/SideBarList';
import SideBarCard02 from '../../../../components/SideBarCard02';

import LMP from '../../img/lmp.png';
import Labsolda from '../../img/labsolda.png';
import Cermat from '../../img/Cermat.png';
import LabMat from '../../img/labmat.png';

export default function ContentLeft() {
  return (
    <Container>
      <SideBarList title="Meus Laboratórios">
        <SideBarCard02
          imgPath={LMP}
          title="LMP"
          subtitle="Laboratório de Mecânica de Precisão"
          route="/lmp"
        />
        <SideBarCard02
          imgPath={LabMat}
          title="LabMat"
          subtitle="Laboratório de Materiais"
          route="/labmat"
        />
      </SideBarList>
      <Gap />
      <SideBarList title="Laboratórios Parceiros">
        <SideBarCard02
          imgPath={Cermat}
          title="CERMAT"
          subtitle="Núcleo de Pesquisas em Materiais Cerâmicos e Compósitos"
          route="/cermat"
        />
        <SideBarCard02
          imgPath={Labsolda}
          title="LABSOLDA"
          subtitle="Instituto de Soldagem e Mecatrônica"
          route="/labsolda"
        />
      </SideBarList>
    </Container>
  );
}
